var _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1078,
    height: 240,
    viewBox: "0 0 1078 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_37_1298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.5,
    cy: 153,
    rx: 309.5,
    ry: 277,
    fill: "#523AE7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_37_1298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 636,
    cy: 140.5,
    rx: 254,
    ry: 246.5,
    fill: "#5829E1"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_37_1298)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 35.5,
    r: 183.5,
    fill: "#97D6E9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_37_1298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1085.5,
    cy: 140,
    rx: 298.5,
    ry: 206,
    fill: "#523AE7"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_37_1298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 858,
    cy: 274,
    rx: 255,
    ry: 239,
    fill: "#9FCEEB"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_37_1298)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1042.5,
    cy: 35,
    rx: 240.5,
    ry: 168,
    fill: "#D3E7B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_37_1298",
    x: -483,
    y: -474,
    width: 1319,
    height: 1254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 175,
    result: "effect1_foregroundBlur_37_1298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_37_1298",
    x: 132,
    y: -356,
    width: 1008,
    height: 993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_37_1298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_37_1298",
    x: -374,
    y: -398,
    width: 867,
    height: 867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_37_1298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_37_1298",
    x: 607,
    y: -246,
    width: 957,
    height: 772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_37_1298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_37_1298",
    x: 353,
    y: -215,
    width: 1010,
    height: 978,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_37_1298"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_37_1298",
    x: 622,
    y: -313,
    width: 841,
    height: 696,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_37_1298"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerGradient);
export default __webpack_public_path__ + "static/media/bannerGradient.d1795007fa3c2ad2073b3d6356d99cec.svg";
export { ForwardRef as ReactComponent };